import { PermissionGroup } from "./permission-group";

export class User {
  id: string = "";
  username: string = "";
  password: string = "";
  email: string = "";
  firstName: string = "";
  lastName: string = "";
  phone: string = "";
  userGroups?: PermissionGroup[];
  userGroupIds: any;
  enabled?: boolean;
  gender?: string;//Todo with enum
  branchCode: string = "";
  cashDeskId?: string;
}
